import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
    vanillajsProjects,
    reactProjects,
    projectIhaveBeenPartOf,
} from "./projectdata";
import Projectcard from "./Projectcard";
import DownArr from "../images/downarr.png";

const useStyles = makeStyles((theme) => ({
    projectSection: {
        display: "flex",
        flexWrap: "wrap",
        [theme.breakpoints.down("sm")]: {
            justifyContent: "space-around",
        },
    },
    myProjectsClosed: {
        maxHeight: "0px",
        overflow: "hidden",
    },
}));

function My_works() {
    const classes = useStyles();
    const { ref, inView } = useInView(); //inview is boolean to say if it is view... ref is to be specified to component that needs to be monitored

    const animation = useAnimation();

    const [toggleOtherProjects, setToggleOtherProjects] = useState(false);

    useEffect(() => {
        if (inView) {
            animation.start({
                opacity: 1,
                transition: {
                    duration: 0.6,
                },
            });
        }
        if (!inView) {
            animation.start({
                opacity: 0,
            });
        }
    }, [inView]);
    return (
        <motion.div id="my_works" ref={ref} animate={animation}>
            <div className={classes.title}>
                <h2>My Projects</h2>
                {/* <p>
                    From corporate achievements to personal projects, each
                    project reflects my dedication to pushing boundaries and
                    transforming ideas into reality. These projects showcase the
                    culmination of my experiences, aspirations, and
                    achievements.
                </p> */}
                <p>
                    The Web3 projects listed below are led by me as the lead
                    developer, while in other projects, I have served as the
                    lead frontend developer.
                </p>

                <p>My Personal Projects can also be viewed via github.</p>

                <div className={classes.projectSection}>
                    {projectIhaveBeenPartOf.map((project) => {
                        return (
                            <Projectcard project={project} key={project.id} />
                        );
                    })}
                </div>
            </div>

            <div>
                <div
                    className=""
                    style={{
                        width: "fit-content",
                        cursor: "pointer",
                        margin: "1rem 0",
                    }}
                    onClick={() => setToggleOtherProjects((prev) => !prev)}
                >
                    <span style={{ fontSize: "1.5rem" }}>
                        <u> Check </u> My other Personal Frontend projects
                    </span>
                    <span style={{ marginLeft: "1rem" }}>
                        <img
                            src={DownArr}
                            width={20}
                            style={{
                                rotate: toggleOtherProjects ? "180deg" : "0deg",
                            }}
                        />
                    </span>
                </div>
                <div
                    className={
                        toggleOtherProjects ? "" : classes.myProjectsClosed
                    }
                >
                    <div>
                        <div className={classes.projectSection}>
                            {vanillajsProjects.map((project) => {
                                return (
                                    <Projectcard
                                        project={project}
                                        key={project.id}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    <div>
                        <div className={classes.projectSection}>
                            {reactProjects.map((project) => {
                                return (
                                    <Projectcard
                                        project={project}
                                        key={project.id}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default My_works;
